import { BiVisualizationWidget } from '@euler/app/components/message/widgets/bi-visualization';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import {
  ServiceFactoryProvider,
  useServiceFactory,
} from '@euler/services/factory';
import { useMemo } from 'react';
import { ScrollView, View } from 'react-native';
import {
  FixtureBiService,
  kExpiredFixtureDraftId,
  kLoadingFixtureDraftId,
} from './FixtureBiService';
import { kBiDraftFixtures } from './biDraftFixtures';

const kFences = [
  ...kBiDraftFixtures.map(draft => ({ draftId: draft.id })),
  { draftId: kExpiredFixtureDraftId, title: '上月营收趋势' },
  { draftId: kLoadingFixtureDraftId, title: '本周工单数' },
];

/** Every `bi_visualization` state, at the width of the AI chat column. */
export const BiVisualizationPlayground = () => {
  const { rpx } = useResponsiveContext();
  const services = useServiceFactory();
  const fixtures = useMemo(
    () => ({ ...services, biService: new FixtureBiService() }),
    [services],
  );
  return (
    <ServiceFactoryProvider serviceFactory={fixtures}>
      <ScrollView
        style={{ flex: 1, backgroundColor: aiColors.background }}
        contentContainerStyle={{ padding: rpx(16), alignItems: 'center' }}
      >
        <View style={{ width: '100%', maxWidth: rpx(724) }}>
          {kFences.map(fence => (
            <BiVisualizationWidget key={fence.draftId} data={fence} />
          ))}
        </View>
      </ScrollView>
    </ServiceFactoryProvider>
  );
};

export const BiVisualizationPlaygroundPage = wrapNavigatorScreen(
  BiVisualizationPlayground,
  { title: 'BI Visualization' },
);
